import style from "./style.module.css";

const NoInternet = () => {
  return <div className={style.noInternet}>...No internet connection</div>;
};

export default NoInternet;
